import React, { useEffect, useState } from "react";
import { Switch, useLocation } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";

const CustomSwitch = ({ children }) => {
  const [progress, setProgress] = useState(false);
  const [prevLoc, setPrevLoc] = useState({ i: 0, path: "" });
  const location = useLocation();

  useEffect(() => {
    if (prevLoc.path !== location.pathname) {
      setPrevLoc({
        i: prevLoc.i + 1,
        path: location.pathname,
      });
      setProgress(true);
    }
    // eslint-disable-next-line
  }, [location]);

  useEffect(() => {
    setProgress(false);
    // console.log(prevLoc.path);
    // if (prevLoc.path === "/" && prevLoc.path !== "/explore") {
    window.scrollTo({
      left: 0,
      top: 0,
    });
    // }
  }, [prevLoc]);

  return (
    <>
      {progress && <TopBarProgress />}
      <Switch>{children}</Switch>
    </>
  );
};

export default CustomSwitch;
